module.exports = __webpack_public_path__ + "static/media/Overnight.0c4c376a.svg";